import React from 'react';

import { StyledFooter } from './Footer.styled';
import { StyledNavLink } from './NavLink.styled';

import { ReactComponent as Logo } from '../../assets/logo.svg';

const Footer = () => {
  return (
    <StyledFooter>
      <div className="logo">
        <Logo className="logo__svg" />
      </div>
      <nav className="navigation">
        <StyledNavLink to="/">Home</StyledNavLink>
        <StyledNavLink to="/articles">Articles</StyledNavLink>
      </nav>
      <p>
        © <span className="nick">TetraMeister</span>, {new Date().getFullYear()}
      </p>
    </StyledFooter>
  );
};

export default Footer;
